import { usePaintPickerContext } from '@modules/paint-picker-new/context/PaintPickerContext';

export const useFeatureFlaggedPaintPickerContext = () => {
    const pickerContext = usePaintPickerContext();
    return { pickerContext };
};
